import React, { useEffect, useContext, createRef, useState } from "react";
import "./AllForGalleryHome.scss";

import RenderComponent, {
  RenderComponentWithWrapper,
  RenderComponentWithPCWrapper
} from "../Gallery/RenderComponent";
import GalleryListWrapper from "../GalleryList/GalleryListWrapper";
import uGalleryListWrapper from "./useGalleryListWrapper";
import {
  getPageSameType,
  getPageGalleryLinkType,
  isIphoneX,
} from "../../utils/util";
import RootStore from "../../store/RootStore";
import { inject, observer } from "mobx-react";
import { action } from "mobx";
import { IMediaListResult } from "../../actions/gallery";
import { ThemeContext } from "../../store/ThemeProvider";
import { IComponent, IComponentCommentSend } from "../../component.d";
import AllForGallerySwitch from "../GalleryList/AllForGallerySwitch";
import AllForCode from "../ComponentCode/AllForCode";
import useRealBottomTab from "../ComponentNavigator/useRealBottomTab";
import { isWeb } from '../../utils/util';
import { videoTypeTransformer } from './DetailTransformer';
import URLUtil from '../../utils/url';
import asyncComponent from '../AsyncComponent';

interface IAllForGalleryHome {
  rootStore?: RootStore;
}

const VideoPCMode = asyncComponent(() => import('./VideoPCMode'));

const AllForGalleryHome = (props: IAllForGalleryHome) => {
  const { pageDetail, configDetail } = window;
  // const { template } = pageDetail;
  const galleryComponent = uGalleryListWrapper(null, [`photo`, `tagphoto`]);
  const { pagedataStore, imStore } = props.rootStore!;
  const { backgroundColor, componentColor, h1Color, mainColor, h2Color } = useContext(ThemeContext);

  const [template, setTemplate] = useState([] as IComponent[]);

  const urlParse = URLUtil(window.location.href);

  useEffect(() => {
    // 判断一下

    if (isWeb()) {
      let result = [] as IComponent[];
      // @ts-ignore
      if (pageDetail.type == 'video' && isWeb()) {
        // if(pageDetail.type == 'video' && urlParse && urlParse.query && urlParse.query.mode == 'pc') {
        result = videoTypeTransformer(pageDetail, configDetail);
        setTemplate(result);
        window.pageDetail.originTemplate = [
          ...window.pageDetail.template
        ];
        window.pageDetail.template = result;
        pagedataStore.setRenderMode('pc');
      } else {
        setTemplate(pageDetail.template as IComponent[]);
      }
    } else {
      setTemplate(pageDetail.template as IComponent[]);
    }
  }, [pageDetail]);

  // 检测一下组件变更提醒
  useEffect(() => {
    let timer = 0;
    const onComponentChange = (data: any) => {
      if (data) {
        const { link_id, component } = data;
        if (component && component.cid && link_id == pageDetail.link_id) {
          // 同一个界面，才刷新一下
          // 如果是挂件的话，还需要单独处理一下
          if (component && component.type == 'pendent') {
            // 不处理，交给具体的地方
          } else {
            const deepSearch = (it: IComponent) => {
              if (it.cid == component.cid) {
                return {
                  ...it,
                  ...component
                };
              }
              // @ts-ignore
              if (it.list instanceof Array && it.list.length) {
                // @ts-ignore
                it.list = it.list.map(deepSearch);
              }
              // @ts-ignore
              if (it.children instanceof Array && it.children) {
                // @ts-ignore
                it.children = it.children.map(deepSearch);
              }
              return it;
            };
            const newTemplate = template.map(deepSearch);

            // 延迟一定的时间，再去更新界面
            window.clearTimeout(timer);
            timer = window.setTimeout(() => {
              setTemplate(newTemplate)
            }, Math.round(Math.random() * 15000));
            // setTemplate(newTemplate);
          }
        }
      }
    };

    imStore.addMessageListener('component_refresh', onComponentChange);

    return () => {
      window.clearTimeout(timer);
      imStore.removeMessageListener('component_refresh', onComponentChange);
    };
  }, [template]);

  // 获取所有视频的数据
  useEffect(() => {
    // 2020-05-07 已经不需要在界面开始的时候去获取了，视频页单独做成装修了
    // const videos = getPageSameType(template, [], 'video');
    // console.log(videos, 'videos');
    // if (videos && videos.length) {
    //   props.rootStore!.galleryStore.getMediaList(window.gallery.id + '');
    // }

    // 过滤获取界面所有涉及的相册
    const galleryids = getPageGalleryLinkType(
      template,
      [],
      ["gallery", "subgallery"]
    );
    pagedataStore.getGallerys(galleryids);
  }, [template]);
  // console.log(galleryComponent)

  // 现在需要去设置一下整个界面要padding多少了
  const galleryHome = createRef<HTMLDivElement>();
  useEffect(() => {
    let paddingBottom = isIphoneX() ? 22 : 0;
    const { showNavigator } = useRealBottomTab();
    if (showNavigator) {
      paddingBottom += 49;
    }
    const commentsend = getPageSameType(template, [], ["commentsend"]);
    if (commentsend && commentsend.length) {
      paddingBottom += 66;

      // if (commentsend && commentsend[0]) {
      //   if ((commentsend[0] as IComponentCommentSend).emotion) {
      //     paddingBottom += 73 + 15;
      //   }
      // }
    }
    if (galleryHome && galleryHome.current) {
      galleryHome.current!.style.paddingBottom =
        Math.max(0, paddingBottom) + "px";
    }
  }, [template]);

  return (
    <div
      ref={galleryHome}
      className="gallery-home"
    // style={{ backgroundColor: backgroundColor }}
    >
      {pagedataStore.renderMode == 'pc' ? <VideoPCMode /> : null}
      <GalleryListWrapper component={galleryComponent}>
        <>
          {template.map((component) => {
            const { type, cid } = component;
            // console.log("render component", cid, type);
            if (pagedataStore.renderMode == 'pc') {
              return <RenderComponentWithPCWrapper key={cid} {...component} />
            } else {
              // pendent比较特殊，因为不需要渲染外层的wrapper，所以在这里单独处理
              if (type === "pendent") {
                return (
                  <React.Fragment key={cid}>
                    <RenderComponent {...component} />
                  </React.Fragment>
                );
              }
              return <RenderComponentWithWrapper key={cid} {...component} />;
            }
          })}
        </>
      </GalleryListWrapper>
      {window.configDetail.global_css || window.configDetail.global_js ? (
        <AllForCode
          type="code"
          cid={"global_script"}
          js={window.configDetail.global_js || ""}
          css={window.configDetail.global_css || ""}
          container={{ top: 0, bottom: 0, left: 0, right: 0 }}
        />
      ) : null}
      {window.pageDetail &&
        window.pageDetail.type != "form" && pagedataStore.renderMode != 'pc' &&
        Number(window.pageDetail.parent) ? (
        <AllForGallerySwitch />
      ) : null}
    </div>
  );
};

export default inject("rootStore")(observer(AllForGalleryHome));
